:host {
  --aha-card-row--padding: 0 var(--spacer-05);
  display: flex;
  justify-content: space-between;
  padding: var(--aha-card-row--padding);
  flex-wrap: wrap;
}

::slotted(aha-card-group:last-child:not(:only-child)) {
  justify-content: flex-end;
}
